import { TableFilter } from "@interfaces/System/TableFilter";

class TableFilterManager {
    public static exclude = (filters: TableFilter[], fields: string[]) => {
        return filters.filter((i) => !fields.includes(i.ptype));
    };
}

export default TableFilterManager;
